import { Component } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-tutores',
  templateUrl: './tutores.component.html',
  styleUrls: ['./tutores.component.css'],
})
export class TutoresComponent {

  apiURL = 'https://citsistemas3.uncu.edu.ar/internacionales/';

  formulario: any = {
    dni: '',
    nombres: '',
    apellidos: '',
    nro_tel_fijo: '',
    nro_tel_celu: '',
    correo: '',
    correo_alt: '',
    facebook: '', /*Fin Información Personal*/
    instagram: '',
    carrera: '',
    facultad: '',
    anio_cursando: '', /*Fin Informacion Acádemica*/
    resultado: '',
    idiomas: false,
    idioma1_text: '',
    idioma1: '',
    idioma2_text: '',
    idioma2: '',
    idioma3_text: '',
    idioma3: '',
    idioma4_text: '',
    idioma4: '', /*Fin Idiomas */
    participacion_anterior: false,
    semestre_participado: '',
    anios_participados: '',
    intercambio_ant: false,
    detalle_intercambio: '', /*Fin Actividades Movilidad Académica*/
    convocatoria: '',
    certificado: '',
    id_convocatoria: ''
  };

  facultad = [
    {
      valor: '1',
      nombre: 'Facultad de Cs. Económicas'
    },
    {
      valor: '2',
      nombre: 'Facultad de Cs. Políticas y Sociales'
    },
    {
      valor: '3',
      nombre: 'Facultad de Cs. Médicas'
    },
    {
      valor: '4',
      nombre: 'Facultad de Ingeniería'
    },
    {
      valor: '5',
      nombre: 'Facultad de Odontología'
    },
    {
      valor: '6',
      nombre: 'Facultad de Artes y Diseño'
    },
    {
      valor: '7',
      nombre: 'Facultad de Filosofía y Letras'
    },
    {
      valor: '8',
      nombre: 'Facultad de Derecho'
    },
    {
      valor: '9',
      nombre: 'Facultad de Educación'
    },
    {
      valor: '10',
      nombre: 'Facultad de Cs. Agrarias'
    },
    {
      valor: '11',
      nombre: 'Facultad de Cs. Aplicadas a la Industria'
    },
    {
      valor: '12',
      nombre: 'Facultad de Cs. Exactas y Naturales'
    },
    {
      valor: '13',
      nombre: 'Inst. Tecnológico Universitario - ITU'
    }];

  anio_cursando = [
    {
    valor: '1',
      descripcion: '1°'
    },
    {
      valor: '2',
      descripcion: '2°'
    },
    {
      valor: '3',
      descripcion: '3°'
    },
    {
      valor: '4',
      descripcion: '4°'
    },
    {
      valor: '5',
      descripcion: '5°'
    },
    {
      valor: '6',
      descripcion: '6°'
    },
    {
      valor: '7',
      descripcion: 'Terminé el cursado, sólo me resta rendir finales/tesis'
    }];

  idioma: any[] = ['No', 'Sí'];
  participado_ant: any[] = ['No', 'Sí'];
  intercambio_ant: any[] = ['No', 'Sí'];

  nivel_idioma = [
    {
      valor: '1',
      descripcion: 'Intermedio'
    },
    {
      valor: '2',
      descripcion: 'Avanzado'
    }
    ];

  semestre_part = [
    {
      valor: '1',
      descripcion: '1°'
    },
    {
      valor: '2',
      descripcion: '2°'
    }
    ];

  anios_part = [
    {
      valor: '1',
      descripcion: '2013'
    },
    {
      valor: '2',
      descripcion: '2014'
    },
    {
      valor: '3',
      descripcion: '2015'
    },
    {
      valor: '4',
      descripcion: '2016'
    },
    {
      valor: '5',
      descripcion: '2017'
    },
    {
      valor: '6',
      descripcion: '2018'
    },
    {
      valor: '7',
      descripcion: '2019'
    },
    {
      valor: '8',
      descripcion: '2020'
    },
    {
      valor: '9',
      descripcion: '2021'
    }
  ];

    resultado = '';

    file_data: any = '';

    rutaArchivo = '';

    nombreRuta = '';

    procesar: boolean;


  constructor(private http: HttpClient) {
    this.consultarConvocatoria();
  }

  registrarse(formulario) {

    const msj = 'Error al registrarse';
    const body = JSON.stringify(  { 'dni': this.formulario.dni, 'nombres': this.formulario.nombres, 'apellidos': this.formulario.apellidos, 'nro_tel_fijo': this.formulario.nro_tel_fijo,
      'nro_tel_celu': this.formulario.nro_tel_celu, 'correo': this.formulario.correo, 'correo_alt': this.formulario.correo_alt, 'instagram': this.formulario.instagram, 'facebook': this.formulario.facebook,
      'carrera': this.formulario.carrera, 'facultad': this.formulario.facultad, 'anio_cursando': this.formulario.anio_cursando, 'idioma1': this.formulario.idioma1_text + ' ' + this.formulario.idioma1,
      'idioma2': this.formulario.idioma2_text + ' ' + this.formulario.idioma2, 'idioma3': this.formulario.idioma3_text + ' ' + this.formulario.idioma3, 'idioma4': this.formulario.idioma4_text + ' ' + this.formulario.idioma4,
      'semestre_participado': this.formulario.semestre_participado, 'anios_participados': this.formulario.anios_participados, 'detalle_intercambio': this.formulario.detalle_intercambio, 'id_convocatoria': this.formulario.id_convocatoria,
      'certificado': this.nombreRuta });

    const promise = new Promise((resolve, reject) => {
      this.procesar = true;
      const apiURL = this.apiURL + '?ai=maca2||3475';
      this.http.post(apiURL, body)
        .subscribe(
          (res: any) => {
            this.procesar = false;
            this.uploadFile();
            this.resultado = res.registro;
          },
          msg => {
            reject(msj);
            this.procesar = false;
            this.resultado = '';
          });
    });
    return promise;
  }

  consultarConvocatoria() {  // Consulta operacion para los tutores
    const msjError = 'Error al obtener la convocatoria';
    const promise = new Promise((resolve, reject) => {
      const apiURL = this.apiURL + '?ai=maca2||3473';
      this.http.get(apiURL, {})
        .subscribe(
          (res: any) => {
            this.formulario.convocatoria = res.descripcion;
            this.formulario.id_convocatoria = res.id_convocatoria;
            // console.log(res);
          },
          msg => {
            console.log(msjError);
            reject(msjError);
          });
    });
    return promise;
  }

  inputValue(input: any) {
    // console.log(input);
    let tempValor: any;
    tempValor = input.currentTarget.value;
    tempValor = tempValor.split('\\');
    this.rutaArchivo = tempValor[tempValor.length - 1];
  }

  fileChange(index: any, event: any) {
    const fileList: FileList = event.target.files;
    // check whether file is selected or not
    if (fileList.length > 0) {
      const file = fileList[0];
      // get file information such as name, size and type
      const extension = file.name.split('.')[1];
      const nombreArchivo = this.formulario.dni + '_' + this.formulario.id_convocatoria + '.' + extension;
      this.nombreRuta = nombreArchivo;
      // max file size is 4 mb
      if ((file.size / 1048576) <= 4) {
        const formData = new FormData();
        const info = {name: 'certificado'}
        formData.append('file', file, nombreArchivo);
        formData.append('id', '2');
        formData.append('tz', new Date().toISOString());
        formData.append('update', '2');
        formData.append('info', JSON.stringify(info));
        this.file_data = formData;
      } else {
        // this.snackBar.open('File size exceeds 4 MB. Please choose less than 4 MB','',{duration: 2000});
      }
    }
  }

  uploadFile() {
    this.http.post(this.apiURL + '?ai=maca2||3485', this.file_data)
      .subscribe(res => {
        // send success response
        // console.log(res);
      }, (err) => {
        // send error response
        console.log(err);
      });
  }

}
